import {MD_WIDTH, LG_WIDTH} from "@main/helpers/const";

const TIMEOUT_RESIZE_OBSERVER = 200;
const NUMBER_VISIBLE_CARDS_ON_MOBILE = 4;
const NUMBER_VISIBLE_CARDS_ON_TABLET = 6;

class ShowMoreCard {
    constructor(el) {
        this.el = el;
        this.listCards = this.el.querySelector(".js-cards-list");
        this.btn = this.el.querySelector(".js-show-more-cards-btn");
        this.prevWidth = document.body.offsetWidth;
        this.resizeObserver = new ResizeObserver(this.onResizeWindow.bind(this), TIMEOUT_RESIZE_OBSERVER);
        this.resizeObserver.observe(document.body);

        if (this.btn) {
            this.listenEvents();
            this.toggleVisibilityBtn();
        }
    }

    listenEvents() {
        this.btn.addEventListener("click", this.showMoreCard);
    }

    showMoreCard = () => {
        if (window.innerWidth < LG_WIDTH ||
            window.innerWidth >= LG_WIDTH && this.listCards.classList.contains("all-mq")) {
            this.listCards.classList.add("expand");
            this.btn.classList.add("hidden");
        }
    };

    toggleVisibilityBtn() {
        if (!this.listCards.classList.contains("js-partners-cards")) return;

        if (window.innerWidth < MD_WIDTH) {
            if(this.listCards.childElementCount > NUMBER_VISIBLE_CARDS_ON_MOBILE ) {
                this.btn.classList.remove("hidden");
            } else {
                this.btn.classList.add("hidden");
            }
        }

        if (window.innerWidth >= MD_WIDTH && window.innerWidth < LG_WIDTH) {
            if(this.listCards.childElementCount > NUMBER_VISIBLE_CARDS_ON_TABLET ) {
                this.btn.classList.remove("hidden");
            } else {
                this.btn.classList.add("hidden");
            }
        }
    }

    onResizeWindow([entry]) {
        const width = document.body.offsetWidth;
        if (width !== this.prevWidth) {
            this.prevWidth = width;

            if (entry.contentRect.width < LG_WIDTH) {
                this.cancelUnfoldingList();
                this.toggleVisibilityBtn();
            }
        }
    }

    cancelUnfoldingList = () => {
        if (this.listCards.classList.contains("expand")) {
            this.listCards.classList.remove("expand");        
            this.btn.classList.remove("hidden");
        }
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-show-more-cards")
        .forEach(card => new ShowMoreCard(card));
});
